import { Toaster } from "react-hot-toast";
import Layout from "../shared/Layout";
import { useCallback, useEffect, useState } from "react";
import { API_URL, baseurl } from "../../_config";
import axios from "axios";
import DataTable from "react-data-table-component";
import toast from "react-hot-toast";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";

const oneLineStyle = {
    display: "block",
    width: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
};

const oneLineLinkStyle = {
    ...oneLineStyle,
    color: "#0d8bff",
    cursor: "pointer",
    textDecoration: "underline",
    fontWeight: "normal",
};

const statusSelectStyle = {
    minWidth: "120px",
    height: "34px",
    padding: "5px 10px",
    borderRadius: "6px",
    border: "1px solid #6a3bbd",
    background: "#100d24",
    color: "#fff",
    outline: "none",
};

const matchTableStyles = {
    rows: {
        style: {
            minHeight: "58px",
        },
    },
    cells: {
        style: {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
        },
    },
    headCells: {
        style: {
            whiteSpace: "nowrap",
        },
    },
};

function formatMatchDate(value) {
    if (!value) return "-";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;

    const formattedDate = date.toISOString().split("T")[0];
    const time = date.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
    });

    return `${formattedDate} ${time}`;
}

const MatchesList = () => {
    const params = useParams();
    const tournmentId = params?.id || null;
    const storedUserData = sessionStorage.getItem('userData');
    const userData = storedUserData ? JSON.parse(storedUserData) : null;
    const [matchId, setMatchId] = useState(0);
    const [matches, setMatches] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isFormOpen, setIsFormOpen] = useState(false);
    const [tournamentName, setTournamentName] = useState("");

    const [tournaments, setTournaments] = useState([]);
    const [teams, setTeams] = useState([]);

    const [formData, setFormData] = useState({
        id: 0,
        tournament_id: tournmentId || "",
        teamA_id: "",
        teamB_id: "",
        match_type: "League",
        venue: "",
        match_date: "",
        status: "upcoming",
        totalOver: 0
    });

    // ✅ Fetch tournaments
    const fetchTournaments = async () => {
        try {
            const res = await axios.get(`${baseurl}${API_URL.getTournaments}`);
            if (res.status === 200) {
                setTournaments(res.data?.data || []);
            }
        } catch {
            toast.error("Failed to load tournaments");
        }
    };

    // ✅ Fetch teams
    const fetchTeams = async () => {
        try {
            const res = await axios.get(`${baseurl}${API_URL.getTeams}`);
            if (res?.data?.status === true) {
                const filteredData = res?.data?.data?.filter((item => item?.type === 'team'));
                setTeams(filteredData || []);
            }
        } catch {
            toast.error("Failed to load teams");
        }
    };

    // ✅ Fetch all matches
    const fetchMatches = useCallback(async () => {
        setLoading(true);
        try {
            let res;

            if (!tournmentId) {
                // 🟢 no const here
                res = await axios.get(`${baseurl}${API_URL.getAll}`);
            } else {
                // 🟢 no const here
                res = await axios.get(`${baseurl}${API_URL.getMatchesByTournamentId}?tournament_id=${tournmentId}`);
            }

            if (res?.status === 200) {
                setMatches(res.data?.data || []);

                // ✅ Set tournament name from first record
                if (tournmentId && res?.data?.data?.length > 0) {
                    setTournamentName(res?.data?.data[0].tournamentName);
                }
            }
        } catch (err) {
            toast.error("Failed to load matches");
        } finally {
            setLoading(false);
        }
    }, [tournmentId]);

    useEffect(() => {
        fetchTournaments();
        fetchTeams();
    }, []);

    useEffect(() => {
        fetchMatches();
    }, [fetchMatches]);

    // ✅ Handle input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    // ✅ Submit form
    const handleSubmit = async (e) => {
        e.preventDefault();

        const safeData = {
            id: formData.id ?? null,
            tournament_id: formData.tournament_id ?? null,
            teamA_id: formData.teamA_id ?? null,
            teamB_id: formData.teamB_id ?? null,
            match_type: formData.match_type ?? null,
            venue: formData.venue ?? null,
            match_date: formData.match_date ?? null,
            status: formData.status ?? "upcoming",
            totalOver: isNaN(Number(formData.totalOver)) ? 0 : Number(formData.totalOver)
        };

        try {
            const res = await axios.post(`${baseurl}${API_URL.saveMatch}`, safeData);

            if (res.data.isSuccess === 1) {
                toast.success(matchId ? "Match updated successfully!" : "Match created successfully!");
                handleClose();
                fetchMatches();
            } else {
                toast.error(res.data.message || "Failed to save match");
            }
        } catch (err) {
            toast.error("Error saving match. Please try again.");
        }
    };

    // ✅ Edit match
    const handleEdit = (item) => {
        setMatchId(item.id);
        setIsFormOpen(true);

        // ⭐ Convert date format for datetime-local
        const formattedDate = item.match_date
            ? new Date(item.match_date).toISOString().slice(0, 16)
            : "";

        setFormData({
            id: item.id,
            tournament_id: item.tournament_id,
            teamA_id: item.teamA_id,
            teamB_id: item.teamB_id,
            match_type: item.match_type,
            venue: item.venue,
            match_date: formattedDate,  // ✅ FIXED
            status: item.status,
            totalOver: Number(item.totalOver),
        });
    };

    // ✅ Delete match
    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure you want to delete this match?")) return;
        try {
            const res = await axios.delete(`${baseurl}${API_URL.deleteMatch}?id=${id}`);
            if (res.data.isSuccess === 1) {
                toast.success("Match deleted successfully!");
                fetchMatches();
            } else {
                toast.error(res.data.message || "Failed to delete match");
            }
        } catch {
            toast.error("Error deleting match.");
        }
    };

    // ✅ Reset form
    const handleClose = () => {
        setIsFormOpen(false);
        setMatchId(0);
        setFormData({
            id: 0,
            tournament_id: "",
            teamA_id: "",
            teamB_id: "",
            match_type: "League",
            venue: "",
            match_date: "",
            status: "upcoming",
            totalOver: 0
        });
    };

    // ✅ Update Toss & Create Innings
    const updateMatchStatus = async (matchId, status) => {
        try {
            await axios.put(`${baseurl}${API_URL.updateMatchStatus}`, {
                matchId,
                status
            });

            toast.success("Match Status Updated");
            fetchMatches();     // refresh table

        } catch (error) {
            console.error("Error updating status:", error);
            toast.error("Failed to update status");
        }
    };

    // ✅ Table columns
    const columns = [
        { name: "S.No", selector: (row, i) => i + 1, width: "70px" },
        {
            name: "Tournament",
            selector: (row, i) => (
                <span
                    style={oneLineLinkStyle}
                    title={`${row.tournamentName || "-"} - Match ${i + 1}`}
                    onClick={() => row?.status === 'completed' || row?.status === 'live' ? window.location.href = `/matches-status/${row.id}` : ''}
                >
                    {`${row.tournamentName} - Match ${i + 1}`}
                </span>
            ),
            sortable: true,
            minWidth: "260px",
        },
        { name: "Team A", selector: (row) => row.teamA_name || "-", sortable: true, minWidth: "170px" },
        { name: "Team B", selector: (row) => row.teamB_name || "-", sortable: true, minWidth: "170px" },
        { name: "Type", selector: (row) => row.match_type, minWidth: "120px" },
        { name: "Venue", selector: (row) => row.venue, minWidth: "180px" },
        {
            name: "Date",
            selector: (row) => formatMatchDate(row.match_date),
            minWidth: "180px",
        },
        { name: "Toss Win", selector: (row) => row.toss_winner_name, minWidth: "150px" },
        { name: "Total Over", selector: (row) => row.totalOver, minWidth: "120px" },
        {
            name: "Status",
            cell: (row) => (
                <select
                    value={row.status}
                    onChange={(e) => updateMatchStatus(row.id, e.target.value)}
                    style={statusSelectStyle}
                >
                    <option value="upcoming">Upcoming</option>
                    <option value="live">Live</option>
                    <option value="completed">Completed</option>
                    <option value="cancelled">Cancelled</option>
                </select>
            ),
            minWidth: "150px",
        },
        {
            name: "Action",
            cell: (row) => (
                <div className="d-flex" style={{ gap: "10px" }}>
                    <span onClick={() => handleEdit(row)} title='Edit' className='edit_icon_wepper'>
                        <svg id="Layer_1" viewBox="0 0 512 512" width="18" height="18" xmlns="http://www.w3.org/2000/svg">
                            <g transform="matrix(1,0,0,1,0,0)">
                                <path d="m41.3 512c-22.8 0-41.3-18.5-41.3-41.3 0-2.6.2-5.2.7-7.7l27.3-144.8c1.5-8.2 5.5-15.7 11.4-21.5l274-274c14.7-14.7 35.1-22.7 57.7-22.7 8.1 0 16.1 1 24 2.8 25.5 5.9 51.1 20.7 72.2 41.8s36 46.7 41.8 72.2c7.4 31.9.2 61.7-19.8 81.7l-274 274c-5.9 5.9-13.4 9.8-21.5 11.4l-144.8 27.4c-2.5.5-5.1.7-7.7.7zm51.8-93.1 72.9-13.8 182-182-59.1-59.1-182 182zm313.3-254.2 23.1-23.1c.2-5.4-3.8-21.8-20.6-38.5-10.1-10.2-22-17.4-32.4-19.8-1.8-.4-3.7-.7-5.5-.7h-.7l-23 23z" fill="#ff7722" />
                                <path d="m499.4 119.1c-5.4-23.7-19.4-47.6-39.1-67.4s-43.8-33.7-67.4-39.1c-28.5-6.6-54.9-.4-72.3 17.1l-274 274c-4.5 4.4-7.5 10.1-8.7 16.3l-27.4 144.9c-3.2 17 8 33.4 24.9 36.6 1.9.4 3.9.5 5.8.5s3.9-.2 5.8-.5l145-27.4c6.2-1.2 11.9-4.2 16.3-8.6l274-274c17.5-17.5 23.7-43.9 17.1-72.4zm-328.5 295.3-90.3 17 17-90.3 191.3-191.3 73.3 73.3zm267.2-267.2-31.7 31.7-73.2-73.3 31.7-31.7c1-1 5.6-2.3 14-.4 12.2 2.8 25.8 11 37.2 22.4 23.5 23.7 25.6 47.7 22 51.3z" fill="#ff7722" />
                                <defs>
                                    <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
                                        <stop offset="0%" stopColor="#526484" />
                                        <stop offset="100%" stopColor="#0063ff" />
                                    </linearGradient>
                                </defs>
                            </g>
                        </svg>
                    </span>
                    <span onClick={() => handleDelete(row.id)} title='Delete' className="delete_icon_weepr">
                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 24 24">
                            <path d="M 10 2 L 9 3 L 4 3 L 4 5 L 5 5 L 5 20 C 5 20.522222 5.1913289 21.05461 5.5683594 21.431641 C 5.9453899 21.808671 6.4777778 22 7 22 L 17 22 C 17.522222 22 18.05461 21.808671 18.431641 21.431641 C 18.808671 21.05461 19 20.522222 19 20 L 19 5 L 20 5 L 20 3 L 15 3 L 14 2 L 10 2 z M 7 5 L 17 5 L 17 20 L 7 20 L 7 5 z M 9 7 L 9 18 L 11 18 L 11 7 L 9 7 z M 13 7 L 13 18 L 15 18 L 15 7 L 13 7 z" fill="#FF0000"></path>
                        </svg>
                    </span>
                </div>
            ),
        },
    ];

    return (
        <Layout>
            <Toaster position="top-right" />
            <div className="right-content-section">
                <div className="admin-page mt-3 d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center gap-3">
                        <Link to="/tournament" className="back_button">
                            <i className="fas fa-arrow-left"></i>
                        </Link>
                        <h4 className="mb-0">{tournmentId ? `${tournamentName} - Matches` : "Matches"}</h4>
                    </div>
                    {userData?.role === 2 && (
                        <div className="add_btn">
                            <button onClick={() => setIsFormOpen(true)}>Add Match</button>
                        </div>
                    )}
                </div>

                <div className="datatable mt-4">
                    <DataTable
                        columns={columns}
                        data={matches}
                        customStyles={matchTableStyles}
                        progressPending={loading}
                        pagination
                        highlightOnHover
                        responsive
                    />
                </div>

                <div id="entryformContainer" className={`adminform entryform ${isFormOpen ? "open" : ""}`}>
                    <div className="closebtn">
                        <button onClick={handleClose}>
                            <svg clipRule="evenodd" fillRule="evenodd" height="30" imageRendering="optimizeQuality" shapeRendering="geometricPrecision" textRendering="geometricPrecision" viewBox="0 0 6.82666 6.82666" width="30" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink" >
                                <g transform="matrix(1,0,0,1,0,0)">
                                    <g id="Layer_x0020_1">
                                        <rect fill="#ffffff00" height="6.827" rx="1.507" width="6.827" stroke="none" />
                                        <path d="m2.21002 1.41333-.79669.79669 1.20331 1.20331-1.20331 1.20331.79669.79669 1.20331-1.20331 1.20332 1.20331.79668-.79669-1.2033-1.20331 1.2033-1.20331-.79669-.79669-1.20331 1.2033z" fill="#fffffe" stroke="none" />
                                    </g>
                                </g>
                            </svg>
                        </button>
                    </div>

                    <div className="enForm">
                        <div className="text-center form-heading">
                            <h4>{matchId ? "Edit Match" : "Add Match"}</h4>
                        </div>

                        <form onSubmit={handleSubmit}>
                            <div className="row g-3">

                                <div className="col-md-6">
                                    <label>Tournament</label>
                                    <select
                                        name="tournament_id"
                                        className="form-control"
                                        value={formData.tournament_id}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="">Select Tournament</option>
                                        {tournaments.map((t) => (
                                            <option key={t.id} value={t.id}>{t.tournamentName}</option>
                                        ))}
                                    </select>
                                </div>

                                <div className="col-md-6">
                                    <label>Team A</label>
                                    <select
                                        name="teamA_id"
                                        className="form-control"
                                        value={formData.teamA_id}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="">Select Team A</option>

                                        {teams
                                            .filter((team) => Number(team.id) !== Number(formData.teamB_id))  // ⛔ hide selected B team
                                            .map((team) => (
                                                <option key={team.id} value={team.id}>
                                                    {team.teamName}
                                                </option>
                                            ))
                                        }
                                    </select>
                                </div>

                                <div className="col-md-6">
                                    <label>Team B</label>
                                    <select
                                        name="teamB_id"
                                        className="form-control"
                                        value={formData.teamB_id}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="">Select Team B</option>

                                        {teams
                                            .filter((team) => Number(team.id) !== Number(formData.teamA_id)) // ⛔ hide selected A team
                                            .map((team) => (
                                                <option key={team.id} value={team.id}>
                                                    {team.teamName}
                                                </option>
                                            ))
                                        }
                                    </select>

                                </div>

                                <div className="col-md-6">
                                    <label>Match Type</label>
                                    <select
                                        name="match_type"
                                        className="form-control"
                                        value={formData.match_type}
                                        onChange={handleChange}
                                    >
                                        <option value="League">League</option>
                                        <option value="Knockout">Knockout</option>
                                        <option value="Semi-Final">Semi-Final</option>
                                        <option value="Final">Final</option>
                                    </select>
                                </div>

                                <div className="col-md-6">
                                    <label>Total Over</label>
                                    <input
                                        type="text"
                                        name="totalOver"
                                        className="form-control"
                                        value={formData.totalOver}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label>Venue</label>
                                    <input
                                        type="text"
                                        name="venue"
                                        className="form-control"
                                        value={formData.venue}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label>Match Date</label>
                                    <input
                                        type="datetime-local"
                                        name="match_date"
                                        className="form-control"
                                        value={formData.match_date}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label>Status</label>
                                    <select
                                        name="status"
                                        className="form-control"
                                        value={formData.status}
                                        onChange={handleChange}
                                    >
                                        <option value="upcoming">Upcoming</option>
                                        <option value="live">Live</option>
                                        <option value="completed">Completed</option>
                                        <option value="cancelled">Cancelled</option>
                                    </select>
                                </div>
                            </div>

                            <div className="d-flex form-buttons mt-3" style={{ gap: "15px" }}>
                                <button type="submit" className="btn btn-primary">
                                    {matchId ? "Update Match" : "Add Match"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default MatchesList;
